var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('NavBar'),_c('v-main',{staticClass:"white"},[_c('v-divider',{staticClass:"red darken-4 pt-1"}),_c('router-view',{attrs:{"itemsLegislacao":_vm.itemsLegislacao}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }